import React from "react";

import { Counts } from "../../../../models";

import "./DailyPickupsCard.scss";

export interface DailyPickupsCardProps {
  pickupsCount: Counts;

  onViewOrders: (ids: string[]) => () => void;
}

export function DailyPickupsCard(props: DailyPickupsCardProps) {
  const { pickupsCount, onViewOrders } = props;

  return (
    <div className="daily-pickups-card-component">
      <div className="header">
        <div className="header-title">Pickups</div>
      </div>

      <div className="items-container">
        <div
          className="item-container"
          onClick={onViewOrders(pickupsCount.complete.ids)}
        >
          <div className="item-title">Completed</div>
          <div className="item-value">{pickupsCount.complete.total}</div>
        </div>

        <div className="vertical-divider" />

        <div
          className="item-container"
          onClick={onViewOrders(pickupsCount.scheduled.ids)}
        >
          <div className="item-title">Scheduled</div>
          <div className="item-value">{pickupsCount.scheduled.total}</div>
        </div>

        <div className="vertical-divider" />

        <div
          className="item-container"
          onClick={onViewOrders(pickupsCount.canceled.ids)}
        >
          <div className="item-title">Canceled</div>
          <div className="item-value">{pickupsCount.canceled.total}</div>
        </div>
      </div>
    </div>
  );
}
